import { EconomicsCalculationsDailyValueBase } from './base/economics-calculations-daily-value-base';

export class EconomicsCalculationsDailyValue extends EconomicsCalculationsDailyValueBase { }